import { render, staticRenderFns } from "./PasswordRecoveryInput.vue?vue&type=template&id=2d8d2439&lang=pug&"
import script from "./PasswordRecoveryInput.vue?vue&type=script&lang=ts&"
export * from "./PasswordRecoveryInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports